// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"N0-z","subtitle":"O0-z","wrapper":"P0-z","leftArrow":"Q0-z","rightArrow":"R0-z"};